import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.insights = ReducerFuncs }

export {
  Routes,
  Reducers
}
